<template>
  <a v-if="directory">
    <a-icon type="folder" />
    <router-link
      :to="link"
    >
      {{ directory.fullPath }}
    </router-link>
  </a>
</template>

<script>
import FieldViewer from '@/components/fields/FieldViewer'
import FileEntity from '@/api/files/fileEntity'

export default {
  name: 'FieldViewerDirectory',
  extends: FieldViewer,
  computed: {
    directory () {
      if (!this.value) return null
      return new FileEntity(this.value)
    },
    link () {
      return `/${this.$store.state.currentLocale}/${this.getModuleIdentifierById(this.directory.module_id)}?path=${encodeURIComponent(this.directory.fullPath)}`
    },
  },
}
</script>

<style scoped>

</style>
